module.exports = {"headline":"סיפור בלי כיסוי","desc":"סוף כל סוף האמירה 'פחות זה יותר' הגיעה גם לעולם הביוטי.<span class=\"br\"><br/></span> איך זה קרה? ואיך זה בא לידי ביטוי בשגרת האיפור היומיומית שלנו?","button":{"link":"","text":"קראי עוד"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/Story.json
// module id = 16
// module chunks = 0